import type {
  BlockedDecisionDetail,
  GetBlockedDecisionsQuery,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { mapToAlertValidationDecisionFromCode } from "src/mappers/alert.mappers";
import { AlertValidationDecision } from "src/types/alert";

/** Blocked info per decision for the UI. */
export type BlockedDecisionInfo = {
  blocked: boolean;
  reason?: string;
  details?: BlockedDecisionDetail[];
};

export function toBlockedByDecision(
  alertDecisions: GetBlockedDecisionsQuery["alertDecisions"]
): Map<AlertValidationDecision, BlockedDecisionInfo> {
  const map = new Map<AlertValidationDecision, BlockedDecisionInfo>();
  for (const d of alertDecisions) {
    const decision = mapToAlertValidationDecisionFromCode(d.code);
    if (decision != null) {
      map.set(decision, {
        blocked: d.blocked,
        reason: d.reason ?? undefined,
        details: d.details ?? undefined,
      });
    }
  }
  return map;
}
